<template>
  <div class="user-disease-page">
    <!-- 上：表单；下：预测结果双表。仅点击「分析」后请求接口 -->
    <el-row :gutter="0" class="user-disease-page__row">
      <el-col :span="24" class="user-disease-page__col">
        <div class="grid-content bg-purple user-disease-page__col-inner">
          <el-card class="box-card user-disease-card user-disease-card--input" shadow="hover">
            <div slot="header" class="user-disease-card__header clearfix">
              <i class="el-icon-card-header"></i>
              <span class="user-disease-card__title">输入历史患病信息</span>
            </div>
            <div class="user-disease-card__body-inner user-disease-input-panel">
              <el-form
                ref="form"
                class="user-disease-form user-disease-form--column-fill"
                :model="textForm"
                label-position="top"
                size="mini"
              >
                <el-form-item label="出生日期" class="user-disease-form__item--compact">
                  <el-date-picker
                    v-model="textForm.u_birth_day"
                    class="user-disease-date"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                  />
                </el-form-item>
                <el-form-item label="性别" class="user-disease-form__item--compact user-disease-form__item--radio">
                  <el-radio-group v-model="textForm.u_gender" class="user-disease-radio-group">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="2">女</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="患病历史" class="user-disease-form__item--flex-grow">
                  <el-input
                    class="user-disease-textarea user-disease-textarea--fill"
                    type="textarea"
                    :rows="1"
                    placeholder="可输入 JSON 或文本病程记录，填写后点击「分析」…"
                    v-model="textForm.u_sym"
                  />
                </el-form-item>
                <el-form-item class="user-disease-form__actions">
                  <el-button
                    type="primary"
                    class="user-disease-btn-analyze"
                    :loading="analyzing"
                    @click="onSubmit"
                  >
                    分析
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="0" class="user-disease-page__row user-disease-page__row--after-form">
      <el-col :span="24" class="user-disease-page__col">
        <div class="grid-content bg-purple user-disease-page__col-inner">
          <el-card class="box-card user-disease-card user-disease-card--result" shadow="hover">
            <div slot="header" class="user-disease-card__header user-disease-card__header--accent clearfix">
              <i class="el-icon-card-header-red"></i>
              <span class="user-disease-card__title">患病预测</span>
            </div>
            <div class="user-disease-card__body-inner user-disease-tables-wrap">
              <el-row :gutter="12" type="flex">
                <el-col :xs="24" :md="12" class="user-disease-table-col">
                  <div class="user-disease-table-panel">
                    <el-table
                      class="user-disease-table"
                      :data="leftTableHalf"
                      :height="predictTableHeight"
                      :header-cell-style="{ background: '#363944', color: 'white', border: 'none' }"
                      :row-class-name="tableRowClassName"
                    >
                      <el-table-column prop="index" label="序号" min-width="72" />
                      <el-table-column prop="dis" label="疾病/病症" min-width="120" show-overflow-tooltip />
                      <el-table-column prop="prob" label="患病概率" min-width="96" />
                    </el-table>
                  </div>
                </el-col>
                <el-col :xs="24" :md="12" class="user-disease-table-col">
                  <div class="user-disease-table-panel">
                    <el-table
                      class="user-disease-table"
                      :data="rightTableHalf"
                      :height="predictTableHeight"
                      :header-cell-style="{ background: '#363944', color: 'white', border: 'none' }"
                      :row-class-name="tableRowClassName"
                    >
                      <el-table-column prop="index" label="序号" min-width="72" />
                      <el-table-column prop="dis" label="疾病/病症" min-width="120" show-overflow-tooltip />
                      <el-table-column prop="prob" label="患病概率" min-width="96" />
                    </el-table>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '@/assets/css/main.css';

export default {
  name: "UserDiseasePredict",
  data() {
    return {
      /** 点击「分析」后请求中，用于按钮 loading */
      analyzing: false,
      /** 双表统一高度（px），随窗口变化更新 */
      predictTableHeight: 420,
      textForm: {
        u_birth_day: '2018-05-09',
        u_gender: '1',
        u_sym: "{\n\t\"2020-02-27\": \"咽喉炎\",\n" +
            "\t\"2020-02-29\": \"风热咳嗽\",\n" +
            "\t\"2020-03-02\": \"风寒感冒\",\n" +
            "\t\"2020-03-14\": \"风热咳嗽\"\n}",
      },
      results: [],
    };
  },
  computed: {
    /**
     * 接口返回的预测列表；非数组或尚未返回时视为空数组，避免模板 slice 报错
     * @returns {Array}
     */
    safeResults() {
      return Array.isArray(this.results) ? this.results : [];
    },
    /**
     * 左表：前一半行（与原先 slice(0, length/2) 一致，偶奇条数时与 Math.floor 行为一致）
     * @returns {Array}
     */
    leftTableHalf() {
      const list = this.safeResults;
      const split = Math.floor(list.length / 2);
      return list.slice(0, split);
    },
    /**
     * 右表：后一半行
     * @returns {Array}
     */
    rightTableHalf() {
      const list = this.safeResults;
      const split = Math.floor(list.length / 2);
      return list.slice(split);
    },
  },
  mounted() {
    this.updatePredictTableHeight();
    window.addEventListener("resize", this.updatePredictTableHeight, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updatePredictTableHeight);
  },
  methods: {
    /**
     * 按视口高度设置预测表格高度，避免固定 480 在不同屏幕上不协调
     * 无入参
     */
    updatePredictTableHeight() {
      const h = typeof window !== "undefined" ? window.innerHeight : 800;
      this.predictTableHeight = Math.round(
        Math.min(Math.max(h * 0.38, 320), 520)
      );
    },
    /**
     * 提交表单，请求患病预测接口并写入 results；仅在用户点击「分析」时调用
     * 无入参，请求体为 this.textForm
     */
    onSubmit() {
      this.analyzing = true;
      this.$http
        .post(
          process.env.VUE_APP_API_HOST + "/user_disease_predict",
          this.textForm,
          { "content-type": "application/json" }
        )
        .then((res) => {
          const raw = res.data && res.data.data;
          this.results = Array.isArray(raw) ? raw : [];
        })
        .catch(() => {
          this.results = [];
          this.$message.error("请求失败，请稍后重试");
        })
        .finally(() => {
          this.analyzing = false;
        });
    },
    /**
     * 表格斑马纹行 class
     * @param {{ rowIndex: number }} param0 行索引
     */
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "warning-row1";
      } else if (rowIndex % 2 == 0) {
        return "success-row1";
      }
      return "";
    },
    /**
     * 随机加载示例病人数据到表单（预留方法，供后续绑定按钮等使用）
     * 无入参
     */
    load_patient_rnd() {
      this.$http
        .post(process.env.VUE_APP_API_HOST + "/load_patient_rnd")
        .then((res) => {
          this.textForm = res.data.data;
        });
    },
  },
};
</script>

<style scoped>
.user-disease-page {
  max-width: none;
  width: 100%;
  margin: 0 auto;
  padding: 16px 10px 24px;
  box-sizing: border-box;
}

.user-disease-page__row--after-form {
  margin-top: 18px;
}

.user-disease-page__col {
  display: flex;
  padding: 0;
}

.user-disease-page__col-inner {
  flex: 1;
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

@media (max-width: 991px) {
  .user-disease-table-col + .user-disease-table-col {
    margin-top: 14px;
  }
}

.user-disease-card /deep/ .el-card__header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  height: auto;
  min-height: 44px;
  padding: 10px 14px;
  background: linear-gradient(
    180deg,
    rgba(62, 66, 78, 0.95) 0%,
    rgba(54, 57, 68, 0.92) 100%
  );
}

.user-disease-card--input /deep/ .el-card__header {
  min-height: 40px;
  padding: 8px 12px;
}

.user-disease-card--input .user-disease-card__body-inner {
  padding: 10px 12px 12px;
}

.user-disease-card--result /deep/ .el-card__header {
  border-bottom-color: rgba(238, 102, 102, 0.2);
}

.user-disease-card /deep/ .el-card__body {
  background-color: #363944;
  padding: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.user-disease-card {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.user-disease-card__header {
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

.user-disease-card__title {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.92);
}

.user-disease-card__body-inner {
  padding: 14px 14px 16px;
  flex: 1;
  min-height: 0;
}

.user-disease-input-panel {
  display: flex;
  flex-direction: column;
  min-height: min(38vh, 400px);
}

.user-disease-form--column-fill {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.user-disease-form /deep/ .el-form-item__label {
  color: rgba(255, 255, 255, 0.72);
  padding-right: 0;
  padding-bottom: 4px;
  line-height: 1.25;
  width: 100% !important;
}

.user-disease-form__item--flex-grow {
  flex: 1 1 auto;
  min-height: 0;
  margin-bottom: 8px !important;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.user-disease-form__item--flex-grow /deep/ .el-form-item__content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.user-disease-form__item--compact {
  margin-bottom: 8px !important;
}

.user-disease-form__item--radio /deep/ .el-form-item__content {
  line-height: 28px;
}

.user-disease-textarea--fill {
  flex: 1;
  min-height: 0;
  height: 100%;
}

.user-disease-textarea--fill /deep/ .el-textarea {
  flex: 1;
  min-height: 0;
  height: 100%;
}

.user-disease-textarea--fill /deep/ .el-textarea__inner {
  height: 100% !important;
  min-height: 200px;
  resize: vertical;
  box-sizing: border-box;
  font-size: 13px;
  line-height: 1.55;
  border-radius: 8px;
  background: #2d313a;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.user-disease-textarea--fill /deep/ .el-textarea__inner:focus {
  border-color: rgba(46, 205, 129, 0.55);
  box-shadow: 0 0 0 1px rgba(46, 205, 129, 0.25);
}

.user-disease-textarea--fill /deep/ .el-textarea__inner::placeholder {
  color: rgba(255, 255, 255, 0.35);
}

.user-disease-date {
  width: 100%;
  max-width: 320px;
}

.user-disease-date /deep/ .el-input__inner {
  border-radius: 8px;
  background: #2d313a;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
}

.user-disease-date /deep/ .el-input__inner:focus {
  border-color: rgba(46, 205, 129, 0.55);
}

.user-disease-radio-group /deep/ .el-radio {
  margin-right: 20px;
  color: rgba(255, 255, 255, 0.82);
}

.user-disease-radio-group /deep/ .el-radio__inner {
  background: #2d313a;
  border-color: rgba(255, 255, 255, 0.25);
}

.user-disease-radio-group /deep/ .el-radio__input.is-checked .el-radio__inner {
  background: rgb(46, 205, 129);
  border-color: rgb(46, 205, 129);
}

.user-disease-form__actions {
  margin-bottom: 0;
  flex-shrink: 0;
  margin-top: auto;
  padding-top: 8px;
}

.user-disease-form__actions /deep/ .el-form-item__content {
  display: flex;
  justify-content: flex-end;
}

.user-disease-btn-analyze {
  min-width: 96px;
  padding: 8px 18px;
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 0.04em;
  background-color: rgb(46, 205, 129) !important;
  border-color: rgb(46, 205, 129) !important;
  color: #fff !important;
  box-shadow: 0 4px 14px rgba(46, 205, 129, 0.35);
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
}

.user-disease-btn-analyze:hover,
.user-disease-btn-analyze:focus {
  filter: brightness(1.06);
  box-shadow: 0 6px 18px rgba(46, 205, 129, 0.45);
}

.user-disease-btn-analyze:active {
  transform: translateY(1px);
}

.user-disease-tables-wrap {
  padding-bottom: 12px;
}

.user-disease-table-panel {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

/* 表格配色与项目内其它表格一致（含 td 深色底，避免 Element 默认白底） */
.user-disease-table /deep/ .el-table {
  background-color: #363944;
  color: white;
}

.user-disease-table /deep/ .el-table__header-wrapper {
  background-color: #363944;
}

.user-disease-table /deep/ .el-table__body-wrapper,
.user-disease-table /deep/ .el-table__footer-wrapper {
  background-color: #363944;
}

.user-disease-table /deep/ .el-table__empty-block {
  background-color: #363944;
}

.user-disease-table /deep/ .el-table__empty-text {
  color: rgba(255, 255, 255, 0.55);
}

.user-disease-table /deep/ .el-table::before,
.user-disease-table /deep/ .el-table::after {
  display: none;
}

.user-disease-table /deep/ .el-table th {
  font-weight: 600;
}

.user-disease-table /deep/ .el-table td,
.user-disease-table /deep/ .el-table th {
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.user-disease-table /deep/ tbody tr:hover > td {
  background-color: #4e5260 !important;
}

.user-disease-table /deep/ tbody tr:hover {
  color: black !important;
}

.user-disease-table /deep/ .warning-row1 {
  background: #363944;
}

.user-disease-table /deep/ .warning-row1 > td {
  background-color: #363944 !important;
  border: none;
}

.user-disease-table /deep/ .success-row1 {
  background: #3C3F4A;
}

.user-disease-table /deep/ .success-row1 > td {
  background-color: #3C3F4A !important;
  border: none;
}

.user-disease-table /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.user-disease-table /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 4px;
}
</style>
